import { InjectionToken } from '@angular/core';

export const ENVIRONMENT_INJECTION_TOKEN = new InjectionToken<
  Record<string, unknown>
>('ENVIRONMENT_INJECTION_TOKEN');
